import { usersFilter } from "components/filterForms/UsersFilterForm/usersFilter";
import { Context } from "enums/licenseContext";
import { shouldShowModalForGroupMembership } from "features/Licensing/ContentAssignmentModalLicensingSteps/state/thunks/licensingModalThunk";
import { bindAction } from "interfaces";
import { flatMap, isEmpty, isEqual, map } from "lodash";
import PropTypes from "prop-types";
import { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Dimmer, Loader, Segment } from "semantic-ui-react";
import { UsersAssignmentModal } from "../../../../../components/assignmentModals";
import FormFooter from "../../../../../components/forms/FormFooter";
import ValidatedForm from "../../../../../components/forms/ValidatedForm";
import NoResults from "../../../../../components/noResults/NoResults";
import { Strings } from "../../../../../enums";
import Enrollment from "../../../../../enums/groups/enrollment";
import userListUtils from "../../../../../utils/userListUtils";
import validationSchemas from "../../../../../utils/validationSchemas";
import { addUsersToGroups } from "../../../state/thunks/peopleThunk";
import AutomaticallyDetect from "../../AddEditGroupForms/AutomaticallyDetect/AutomaticallyDetect";
import GroupUsersList from "../../AddGroup/GroupUsers/GroupUsersList/GroupUsersList";

import { NoSearchResults } from "components";
import { updateGroupEnrollmentRules } from "../state/thunks/editGroupInfoThunk";
import "./editPeople.scss";
import UsersFileUploadModal from "../../../../../components/usersFileUploadModal/UsersFileUploadModal";
import * as backgroundTasksActionsRedux from "../../../../BackgroundTasks/state/backgroundTasksActions";
import { showGeneralLoaderWithTimeout } from "../../../../Application/actions/generalLoader/generalLoaderActions";
import * as usersOverviewActionsRedux from "../../../Users/UsersOverview/state/usersOverviewActions";
import typedDataService from "../../../../Application/services/dataServices/typedDataService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsersGear } from "@fortawesome/pro-solid-svg-icons";
import CsvRemoveUsersModal from "../../../../../components/modal/CsvRemoveUsersModal/CsvRemoveUsersModal";
import { FeatureFlags } from "../../../../../featureFlags";
import { withLDConsumer } from "launchdarkly-react-client-sdk";
import RtnEventsEmitter from "features/Application/services/realTimeNotification/rtnEventsEmitter";
import {
  AddGroupEnrollmentRulesAllFailure,
  AddGroupEnrollmentRulesAllSuccess,
} from "features/Application/services/realTimeNotification/events/people/peopleEvents";

const noEnrollmentRules = [
  {
    source: null,
    filter: null,
    type: null,
    value: "",
  },
];

export class EditPeople extends Component {
  constructor(props) {
    super(props);

    const { enrollmentRules, hidePeople, enrollmentType } = this.props;

    const groupMembersFilter =
      enrollmentType === Enrollment.Automatic && !isEmpty(enrollmentRules) && !hidePeople ? enrollmentRules : {};

    this.state = {
      groupMembersAppliedFilter: { ...groupMembersFilter },
      selectedUsersToAddIds: [],
      isAutoEnrollRulesValid: true,
      savedEnrollmentRules: [...enrollmentRules],
      droppedFile: null,
      autoEnrollRefreshing: false,
    };
    this.isGroupCsvUserImportEnabled = !!this.props.flags?.[FeatureFlags.GroupCsvUserImport];
    this.additionalPurchaseEnabled = !!this.props.flags?.[FeatureFlags.AdditionalPurchase];
  }

  componentDidMount() {
    // Subscribe to enrollment rules update completion RTN event
    RtnEventsEmitter.subscribe(AddGroupEnrollmentRulesAllSuccess, this.handleEnrollmentRulesUpdateComplete);
    RtnEventsEmitter.subscribe(AddGroupEnrollmentRulesAllFailure, this.handleEnrollmentRulesUpdateComplete);
  }

  componentDidUpdate(prevProps) {
    const { enrollmentRules } = this.props;

    if (isEmpty(prevProps.enrollmentRules) && !isEmpty(enrollmentRules)) {
      this.applyGroupMembersFilter(enrollmentRules);
      this.setState({ savedEnrollmentRules: [...enrollmentRules] });
    }

    if (!isEqual(prevProps.enrollmentRules, enrollmentRules) && isEqual(prevProps.enrollmentRules, noEnrollmentRules)) {
      this.setState({ savedEnrollmentRules: [...enrollmentRules] });
    }
  }

  componentWillUnmount() {
    const { enrollmentType } = this.props;
    // Unsubscribe from RTN event
    RtnEventsEmitter.unsubscribe(AddGroupEnrollmentRulesAllSuccess, this.handleEnrollmentRulesUpdateComplete);
    RtnEventsEmitter.unsubscribe(AddGroupEnrollmentRulesAllFailure, this.handleEnrollmentRulesUpdateComplete);
    this.props.editGroupActions.resetMembersSearch();
    this.props.editGroupActions.resetGroupUsers();
    if (enrollmentType === Enrollment.Automatic) {
      this.resetGroupMembersFilter();
    }
  }

  loadMembersPage = (skip, top, sortingColumnName, sortingDirection, appliedFilter) => {
    const { fetchGroupUsersForList } = this.props.editGroupActions;
    const { search } = this.props;
    const isAutoEnrollment = false;

    const filterParams = search ? appliedFilter : usersFilter.buildFilterQuery(appliedFilter);
    let orderParams = "";
    if (sortingColumnName && sortingDirection) {
      if (search) {
        orderParams = userListUtils.formatOrderParamsV2(sortingColumnName, sortingDirection);
      } else {
        orderParams = userListUtils.formatOrderParams(sortingColumnName, sortingDirection);
      }
    }

    fetchGroupUsersForList(this.props.groupId, skip, top, orderParams, filterParams, isAutoEnrollment, search);
  };

  loadAutoEnrollMembersPage = (skip, top, orderParams, filterParams) => {
    const { fetchGroupUsersForList } = this.props.editGroupActions;
    const groupId = -1;
    const isAutoEnrollment = true;

    fetchGroupUsersForList(groupId, skip, top, orderParams, filterParams, isAutoEnrollment);
  };

  loadUsersToAddPage = (skip, top, sortingColumnName, sortingDirection, appliedFilter) => {
    const { fetchGroupUsersToAdd } = this.props.editGroupActions;
    const { addUsersSearch } = this.props;

    const filterParams = addUsersSearch ? appliedFilter : usersFilter.buildFilterQuery(appliedFilter);
    let orderParams = "";
    if (sortingColumnName !== null) {
      orderParams = addUsersSearch
        ? userListUtils.formatOrderParamsV2(sortingColumnName, sortingDirection)
        : userListUtils.formatOrderParams(sortingColumnName, sortingDirection);
    }

    fetchGroupUsersToAdd([this.props.groupId], skip, top, orderParams, filterParams, addUsersSearch);
  };

  applyGroupMembersFilter = (filter) => {
    this.setState({ groupMembersAppliedFilter: filter });
  };

  resetGroupMembersFilter = () => {
    this.setState({ groupMembersAppliedFilter: {} });
  };

  onSecondStep = (selectedIds) => {
    const { groupId, shouldShowLicensingModal } = this.props;
    this.setState({ selectedUsersToAddIds: selectedIds });

    return shouldShowLicensingModal([groupId], selectedIds, this.additionalPurchaseEnabled);
  };

  createReloadListItems = (reloadListItems) => {
    this.reloadListItems = reloadListItems;
  };

  onSearchMembersChanged = (search) => {
    this.props.editGroupActions.setMembersSearch(search);
    this.reloadListItems?.(isEmpty(search));
  };

  onAddUsersConfirm = async (notificationSettings) => {
    const { groupId, onCloseAddUsersModal } = this.props;
    const { selectedUsersToAddIds } = this.state;

    this.props.addUsersToGroups(selectedUsersToAddIds, [groupId], notificationSettings);
    onCloseAddUsersModal();
  };

  createReloadListAddItems = (reloadListItems) => {
    this.reloadListAddItems = reloadListItems;
  };

  onSearchUsersAddChanged = (search) => {
    this.props.editGroupActions.setAddMembersSearch(search);
    this.reloadListAddItems?.(isEmpty(search));
  };

  renderUsersAddModal = () => {
    const {
      showAddPeopleModal,
      onCloseAddUsersModal,
      groupId,
      addUsersSearch,
      disableNotifications,
      isShouldShowModalLoading,
    } = this.props;
    const {
      usersToAdd: { items, itemsCount, isLoading },
    } = this.props.editPeople;

    return (
      <UsersAssignmentModal
        loadPage={this.loadUsersToAddPage}
        usersAmount={itemsCount}
        isListLoading={isLoading}
        isStepLoading={isShouldShowModalLoading}
        users={items}
        onSecondStep={this.onSecondStep}
        onConfirm={this.onAddUsersConfirm}
        showModal={showAddPeopleModal}
        onCancel={onCloseAddUsersModal}
        assignmentEntityType="group"
        focusedEntityIds={[groupId]}
        usersAssignments={{
          items: flatMap(items, (item) =>
            map(item.assignedGroupIds, (id) => ({
              userId: item.id,
              groupId: id,
            })),
          ),
          comparer: (assignment, id) => assignment.groupId === id,
        }}
        multipleAssignment={false}
        alreadyAssignedUserTooltip={Strings.tooltipMessages.alreadyAssigned.userToGroup.oneUser}
        showRoleFilter
        search={addUsersSearch}
        onSearchChanged={this.onSearchUsersAddChanged}
        setReloadListItems={this.createReloadListAddItems}
        context={Context.AddPeopleToGroups}
        disableNotifications={disableNotifications}
      />
    );
  };

  onFileDisposed = () => {
    this.setState({ droppedFile: null });
  };

  startUsersImportHandler = (fileName, mappedFields, notificationSettings) => {
    const { groupId } = this.props;
    return typedDataService.users.startUsersImportForGroup(fileName, groupId, mappedFields, notificationSettings);
  };

  renderCsvUsersUploadModal = () => {
    const {
      accountId,
      actorId,
      usersFileUploadStatus,
      usersOverviewActions,
      uploadedUsersFileColumns,
      usersImportPreviewData,
      backgroundTasksActions,
      showGeneralLoaderWithTimeout,
      backgroundTasks,
      usersFileUploadModalOption,
      onCloseUsersFileUploadModal,
    } = this.props;
    const { droppedFile } = this.state;
    return (
      <UsersFileUploadModal
        showNotifyStep
        groupId={this.props.groupId}
        modalTitle="Manage Users"
        notifyLabelText="Send welcome emails to new users only"
        startUsersImport={this.startUsersImportHandler}
        showGeneralLoaderWithTimeout={showGeneralLoaderWithTimeout}
        addBackgroundTask={backgroundTasksActions.addTask}
        removeBackgroundTask={backgroundTasksActions.deleteTask}
        cancelBackgroundTask={backgroundTasksActions.cancelTask}
        accountId={accountId}
        actorId={actorId}
        showModal={usersFileUploadModalOption.showModal}
        showLicenceStep={usersFileUploadModalOption.showLicenceStep}
        onClose={onCloseUsersFileUploadModal}
        isFileUploading={usersFileUploadStatus.isUploading}
        droppedFile={droppedFile}
        onFileDisposed={this.onFileDisposed}
        uploadProgress={usersFileUploadStatus.progress}
        uploadError={usersFileUploadStatus.error}
        uploadUsersFile={usersOverviewActions.uploadUsersFile}
        getUploadedFileColumns={usersOverviewActions.fetchUploadedFileColumns}
        getUsersImportPreviewData={usersOverviewActions.fetchUsersImportPreviewData}
        uploadedUsersFileColumns={uploadedUsersFileColumns}
        cancelUsersFileUpload={usersOverviewActions.cancelUsersFileUpload}
        resetUsersFileUpload={usersOverviewActions.resetUsersFileUpload}
        updateUsersFileUploadProgress={usersOverviewActions.updateUsersFileUploadProgress}
        usersImportPreviewData={usersImportPreviewData}
        resetUsersImportPreviewData={usersOverviewActions.resetUsersImportPreviewData}
        backgroundTasks={backgroundTasks}
      />
    );
  };

  renderCsvRemoveUsersModal = () => {
    const {
      accountId,
      actorId,
      usersFileUploadStatus,
      usersOverviewActions,
      uploadedUsersFileColumns,
      usersImportPreviewData,
      backgroundTasksActions,
      showGeneralLoaderWithTimeout,
      backgroundTasks,
      showCsvRemoveUsersModal,
      onCloseUsersRemoveModal,
    } = this.props;
    const { droppedFile } = this.state;
    return (
      <CsvRemoveUsersModal
        groupId={this.props.groupId}
        startUsersImport={this.startUsersImportHandler}
        showGeneralLoaderWithTimeout={showGeneralLoaderWithTimeout}
        addBackgroundTask={backgroundTasksActions.addTask}
        removeBackgroundTask={backgroundTasksActions.deleteTask}
        cancelBackgroundTask={backgroundTasksActions.cancelTask}
        accountId={accountId}
        actorId={actorId}
        showModal={showCsvRemoveUsersModal}
        onClose={onCloseUsersRemoveModal}
        isFileUploading={usersFileUploadStatus.isUploading}
        droppedFile={droppedFile}
        onFileDisposed={this.onFileDisposed}
        uploadProgress={usersFileUploadStatus.progress}
        uploadError={usersFileUploadStatus.error}
        uploadUsersFile={usersOverviewActions.uploadUsersFile}
        getUploadedFileColumns={usersOverviewActions.fetchUploadedFileColumns}
        getUsersImportPreviewData={usersOverviewActions.fetchUsersImportPreviewData}
        uploadedUsersFileColumns={uploadedUsersFileColumns}
        cancelUsersFileUpload={usersOverviewActions.cancelUsersFileUpload}
        resetUsersFileUpload={usersOverviewActions.resetUsersFileUpload}
        updateUsersFileUploadProgress={usersOverviewActions.updateUsersFileUploadProgress}
        usersImportPreviewData={usersImportPreviewData}
        resetUsersImportPreviewData={usersOverviewActions.resetUsersImportPreviewData}
        backgroundTasks={backgroundTasks}
      />
    );
  };

  renderCustomNoResultContent = () => {
    return isEmpty(this.state.groupMembersAppliedFilter) && !this.props.search ? (
      <NoResults
        title="You don't have any available users"
        description="Looks like the owner of this inherited group hasn't added any users yet."
        iconClassName="fal fa-users"
      />
    ) : (
      <NoSearchResults />
    );
  };

  onFileDropped = (file) => {
    this.setState({ droppedFile: file });
    this.props.handleImportUsers();
  };

  renderGroupUsersList = (isAutoEnrollment, renderHeaderSection) => {
    const { list, filterOptions } = this.props.editPeople;
    const {
      selectedUsers,
      onSelectedUsersChanged,
      onRemoveMemberClick,
      getFilterOptions,
      goToEditUser,
      search,
      hidePeople,
    } = this.props;

    const { groupMembersAppliedFilter } = this.state;

    // For auto-enrollment full list, don't pass enrollment rules as appliedUserFilter
    // since membership is already determined server-side
    const appliedFilter = { ...groupMembersAppliedFilter };
    // Remove the auto-enrollment specific filters when rendering full list
    if (isAutoEnrollment) {
      for (const key of Object.keys(appliedFilter)) {
        if (!isNaN(Number(key))) {
          delete appliedFilter[key];
        }
      }
    }

    return (
      <GroupUsersList
        isGroupCreation={false}
        isAutoEnrollment={isAutoEnrollment}
        users={list.items}
        addMembersBtn={this.props.addMembersBtn}
        usersCount={list.itemsCount}
        isLoading={list.isLoading}
        isDragAndDrop={this.isGroupCsvUserImportEnabled}
        appliedUserFilter={appliedFilter}
        setUserFilter={this.applyGroupMembersFilter}
        resetUserFilter={this.resetGroupMembersFilter}
        selectedItemIds={selectedUsers}
        updateSelectedItems={onSelectedUsersChanged}
        loadPage={this.loadMembersPage}
        withSelection
        renderHeaderSection={renderHeaderSection}
        onRemoveMemberClick={onRemoveMemberClick}
        filterOptions={{ showRoleFilter: true, ...filterOptions }}
        getFilterOptions={getFilterOptions}
        goToEditUser={goToEditUser}
        isReadOnly={this.props.isReadOnly}
        setReloadListItems={this.createReloadListItems}
        search={search}
        onSearchChanged={this.onSearchMembersChanged}
        deepLink={this.props.deepLink}
        hideUserRemoveColumn={hidePeople || isAutoEnrollment}
        customNoResultContent={this.props.isFromTemplateGroup && this.renderCustomNoResultContent}
        onFileDropped={this.onFileDropped}
      />
    );
  };

  renderGroupMembersManualEnroll = () => {
    return (
      <>
        {this.renderGroupUsersList(false, true)}
        {this.renderUsersAddModal()}
        {this.renderCsvUsersUploadModal()}
        {this.renderCsvRemoveUsersModal()}
      </>
    );
  };

  bindGetValidatedValues = (getValidatedValues) => {
    this.getValidatedValues = getValidatedValues;
  };

  handleEnrollmentRulesUpdateComplete = () => {
    // Called when RTN signals enrollment rules update is complete
    this.reloadListItems?.();
    this.setState({ autoEnrollRefreshing: false });
  };

  onAutoEnrollMembersSave = () => {
    const { groupId, updateGroupEnrollmentRules } = this.props;

    const newEnrollmentRules = this.getValidatedValues().enrollmentRules;

    updateGroupEnrollmentRules(groupId, newEnrollmentRules);
    this.resetForm({ values: { enrollmentRules: [...newEnrollmentRules] } });
    this.props.editGroupActions.resetMembersSearch();
    this.resetGroupMembersFilter();
    this.setState({ savedEnrollmentRules: [...newEnrollmentRules], autoEnrollRefreshing: true });
  };

  onAutoEnrollMembersCancel = () => {
    const { savedEnrollmentRules } = this.state;

    this.resetForm({
      values: { enrollmentRules: [...savedEnrollmentRules] },
    });
    this.props.editGroupActions.resetMembersSearch();
    this.applyGroupMembersFilter(savedEnrollmentRules);
    setTimeout(() => this.forceUpdate(), 0); // temporary workaround since the general expression builder component is not ready
  };

  areEnrollmentRulesEdited = () => {
    const { savedEnrollmentRules } = this.state;
    return (
      !this.props.isReadOnly &&
      this.getValidatedValues &&
      !isEqual(this.getValidatedValues().enrollmentRules, savedEnrollmentRules)
    );
  };

  onIsAutoEnrollValidChange = (isValid) => {
    this.setState({ isAutoEnrollRulesValid: isValid });
  };

  renderTabContent = (showUsersList) => {
    if (showUsersList) {
      return this.renderGroupMembersManualEnroll();
    } else {
      return this.renderGroupMembersAutoEnroll();
    }
  };

  areEnrollmentRulesMeaningfullyEdited = () => {
    const currentRules = this.getValidatedValues()?.enrollmentRules || [];
    const { savedEnrollmentRules } = this.state;

    const hasEmptyRules = currentRules.some((rule) => isEmpty(rule.value));
    if (hasEmptyRules) {
      return false;
    }

    // Check if rules are edited
    if (isEqual(currentRules, savedEnrollmentRules)) {
      return false;
    }

    return true;
  };

  renderGroupMembersAutoEnroll = () => {
    const {
      enrollmentRules,
      isReadOnly,
      goToEditUser,
      fetchGroupEnrollmentUsers,
      resetEnrollmentUsers,
      groupEnrollmentUsers,
      hidePeople,
      isFromTemplateGroup,
      editPeople,
    } = this.props;

    const { isAutoEnrollRulesValid, groupMembersAppliedFilter } = this.state;

    const enrollmentLengthWithoutNulls = enrollmentRules?.filter((e) => e.filter !== null).length;

    if (enrollmentLengthWithoutNulls === 0 && isFromTemplateGroup) {
      return (
        <NoResults
          title="No enrollment rules configured"
          description="It seems the owner of this inherited group hasn't set up any enrollment rules yet."
          icon={<FontAwesomeIcon icon={faUsersGear} className="no-results-icon" style={{ margin: 0 }} />}
        />
      );
    }

    return (
      <>
        <ValidatedForm
          isInitialValid
          bindGetValues={this.bindGetValidatedValues}
          className="group-members-auto-enroll"
          initialValues={{
            enrollmentRules: [...enrollmentRules],
          }}
          validationSchema={validationSchemas.automaticEnrollment}
          unsavedChangesPrompt={{
            title: "Exit Without Saving?",
            message: "Are you sure you want to exit without saving? All information entered will be lost.",
          }}
          formWidthComputer={16}
          disablePreventTransitionPrompt={!this.areEnrollmentRulesEdited()}
        >
          {(formProps) => {
            const { values, validatedFieldProps } = formProps;
            this.resetForm = validatedFieldProps.resetForm;
            const showFullList = !this.areEnrollmentRulesMeaningfullyEdited() && !this.state.autoEnrollRefreshing;
            const groupUsersListComponent = this.renderGroupUsersList(true, true);

            const usersCount = showFullList ? editPeople.list.itemsCount : groupEnrollmentUsers.itemsCount;

            return (
              <AutomaticallyDetect
                onIsValidChange={this.onIsAutoEnrollValidChange}
                values={values}
                validatedFieldProps={validatedFieldProps}
                users={groupEnrollmentUsers.items}
                usersCount={usersCount}
                isLoading={groupEnrollmentUsers.isLoading || this.state.autoEnrollRefreshing}
                loadUsers={this.loadAutoEnrollMembersPage}
                gridFilter={groupMembersAppliedFilter}
                setGridFilter={this.applyGroupMembersFilter}
                resetGridFilter={this.resetGroupMembersFilter}
                goToEditUser={goToEditUser}
                disabled={isReadOnly || this.state.autoEnrollRefreshing}
                deepLink={this.props.deepLink}
                fetchGroupEnrollmentUsers={fetchGroupEnrollmentUsers}
                resetEnrollmentUsers={resetEnrollmentUsers}
                hidePeople={hidePeople}
                showFullList={showFullList}
                groupUsersListComponent={groupUsersListComponent}
              />
            );
          }}
        </ValidatedForm>
        <FormFooter
          onSave={this.onAutoEnrollMembersSave}
          isSaveBtnDisabled={!isAutoEnrollRulesValid || !this.areEnrollmentRulesEdited() || isReadOnly}
          onCancel={this.onAutoEnrollMembersCancel}
          isCancelBtnDisabled={!this.areEnrollmentRulesEdited() || isReadOnly}
        />
      </>
    );
  };

  render() {
    const { enrollmentType, isGroupInfoLoading, showUsersList } = this.props;

    return isGroupInfoLoading || enrollmentType === undefined ? (
      <Dimmer.Dimmable className="edit-people-dimmer" as={Segment} dimmed>
        <Dimmer active inverted>
          <Loader active>Loading</Loader>
        </Dimmer>
      </Dimmer.Dimmable>
    ) : (
      this.renderTabContent(showUsersList)
    );
  }
}

EditPeople.defaultProps = {
  enrollmentRules: [],
};

EditPeople.propTypes = {
  groupId: PropTypes.number.isRequired,
  isReadOnly: PropTypes.bool,
  addMembersBtn: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  editGroupActions: PropTypes.object.isRequired,
  editPeople: PropTypes.object.isRequired,
  showAddPeopleModal: PropTypes.bool.isRequired,
  showCsvRemoveUsersModal: PropTypes.bool.isRequired,
  usersFileUploadModalOption: PropTypes.shape({
    showModal: PropTypes.bool.isRequired,
    showLicenceStep: PropTypes.bool.isRequired,
  }),
  handleImportUsers: PropTypes.func,
  onCloseAddUsersModal: PropTypes.func.isRequired,
  onCloseUsersRemoveModal: PropTypes.func.isRequired,
  onCloseUsersFileUploadModal: PropTypes.func.isRequired,
  enrollmentRules: PropTypes.array,
  onRemoveMemberClick: PropTypes.func,
  onSelectedUsersChanged: PropTypes.func,
  enrollmentType: PropTypes.oneOf([0, 1, 2]),
  isGroupInfoLoading: PropTypes.bool,
  selectedUsers: PropTypes.array,
  getFilterOptions: PropTypes.func,
  search: PropTypes.string,
  addUsersSearch: PropTypes.string,
  disableNotifications: PropTypes.bool,
  goToEditUser: PropTypes.func,
  deepLink: PropTypes.bool,
  hidePeople: PropTypes.bool,
  showUsersList: PropTypes.bool,
  fetchGroupEnrollmentUsers: PropTypes.func,
  resetEnrollmentUsers: PropTypes.func,
  groupEnrollmentUsers: PropTypes.shape({
    items: PropTypes.array.isRequired,
    itemsCount: PropTypes.number.isRequired,
    isLoading: PropTypes.bool.isRequired,
  }).isRequired,
  isFromTemplateGroup: PropTypes.bool,
};

/* istanbul ignore next */
const mapStateToProps = (state) => ({
  isShouldShowModalLoading: state.licensing.licensingModal.isLoading,
  enrollmentUsers: state.people.enrollmentUsers,
  backgroundTasks: state.backgroundTasks.tasks,
  accountId: state.userProfile.accountId,
  actorId: state.userProfile.id,
  usersFileUploadStatus: state.people.usersOverview.usersFileUploadStatus,
  uploadedUsersFileColumns: state.people.usersOverview.uploadedFileColumns,
  usersImportPreviewData: state.people.usersOverview.usersImportPreviewData,
});

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) => {
  return {
    addUsersToGroups: bindActionCreators(addUsersToGroups, dispatch),
    shouldShowLicensingModal: bindAction(shouldShowModalForGroupMembership, dispatch),
    updateGroupEnrollmentRules: bindAction(updateGroupEnrollmentRules, dispatch),
    backgroundTasksActions: bindActionCreators(backgroundTasksActionsRedux, dispatch),
    showGeneralLoaderWithTimeout: bindAction(showGeneralLoaderWithTimeout, dispatch),
    usersOverviewActions: bindActionCreators(usersOverviewActionsRedux, dispatch),
  };
};
const ConnectedEditPeople = connect(mapStateToProps, mapDispatchToProps)(withLDConsumer()(EditPeople));
export default ConnectedEditPeople;
